module.exports = __webpack_public_path__ + "static/media/clock-white.abe0565e.svg";